
// export const BIDPACK_ORIGIN_COLUMN_LSIT =['OriginCountry', 'OriginPostcodeArea', 'OriginPostCode', 'OriginGSDB']

export const BIDPACK_ORIGIN_COLUMN_LSIT = [
    {name:'Selected', label:"Selected", selected: false,  orderId:0},
    { name: "OriginCountry", label: "Origin Country", selected: true,  orderId:1 },
    { name: "OriginPostcodeArea", label: "Origin Zip Area", selected: true, orderId:1 },
    { name: "OriginPostCode", label: "Origin Zip Code", selected: true, orderId:1},
    { name: "OriginGSDB", label: "Origin GSDB", selected: true, orderId:1 },
];

export const BIDPACK_DISPLAY_AGREEMENT_COLUMNS = [
    {name:'Selected', label:"Selected", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
    { name: "BidPackStatus", label: "Status", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:1 },
    { name: "BidPackReference", label: "Bid Pack Reference", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:2 },
    { name: "BidPackName", label: "Bid Pack Name", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:3 },
    { name: "BidPackType", label: "Bid Pack Type", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:4 },
    { name: "OriginCountry", label: "Origin Country", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:5 },
    { name: "DestinationName", label: "Destination Name", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:6 },
    { name: "CreatedOn", label: "Created (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:7 },
    { name: "ModifiedOn", label: "Modified (Date/Time)", selected: true, ScreenColumnID: 0, ScreenID: 0, orderId:8 },
    {name:'action', label:"action", selected: false, ScreenColumnID: 0, ScreenID: 0, orderId:0},
];


